import React from "react";
import { AuthContextProvider } from "./store/auth-context";
import RouteProvider from "./route-provider";
import "./App.css";

// set up contexts and initialize routes

export default function App() {
    return (
        <AuthContextProvider>
            <RouteProvider />
        </AuthContextProvider>
    );
}
